// src/components/ReferralHandler.js
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { captureReferralCodeFromUrl } from '../services/referralStorage';

/**
 * Captures a referral code from `?ref=EB-XXXXXX` on any landing URL and
 * stashes it in localStorage so the eventual signup (email or Google OAuth)
 * can forward it to the backend.
 *
 * Mounted as the catch-all route in App.js — runs whenever someone hits a
 * URL that no other route matched. Always redirects to /auth afterwards.
 *
 * Links shared before the backend started emitting /auth?mode=signup point at
 * /signup?ref=... and land here, so a captured code also forces signup mode.
 * A plain 404 (no code) still falls through to /auth in its default log-in
 * mode — a mistyped deep link usually belongs to someone who already has an
 * account.
 */
const ReferralHandler = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const code = captureReferralCodeFromUrl(location.search);
        navigate(code ? '/auth?mode=signup' : '/auth', { replace: true });
    }, [location, navigate]);

    return null;
};

export default ReferralHandler;
